<template>
  <div style="height:100%" class="invite-page">
    <v-toolbar-title class="taption-logo no-nav">
      <router-link :to="getLogoUrl">
        <img alt="logo" :src='"../assets/images/logo_green_title.webp"' style="height:52px; width: 200px; display: block"/>
      </router-link>
      </v-toolbar-title> 
    <LoaderIcon v-show="isPageLoading" :color="'#2fc59F'" class="invite-loader-icon"></LoaderIcon>

    <section ref="signupform" class="authentication-form">
      <v-fade-transition>
        <div v-show="!!userExist" ref="signupcontainer" class="signup-container">
          <h2 class="title text-center">
            <span>{{$lang.login.create_free_account}}</span>
          </h2>
           <div class="invite-card card" >
               <div v-html="inviteDesc"> </div>
               <span class="referral-note">*{{$lang.login.referral_note}}</span>
            </div>
          <div class="signup-card card">
            <v-form ref="form" class="theme-form">
                          <div class="form-button text-center social-btns">
              <v-btn :disabled="isLoginLoading" class="round ggl" type="button" @click="googleLogin">
                <span class="google-button__icon"><svg height="20px" viewBox="0 0 366 372" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" fill="#EA4335" id="Shape"></path><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" fill="#FBBC05" id="Shape"></path><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" fill="#4285F4" id="Shape"></path><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"></path></svg></span>
                {{$lang.login.signin_google}}
              </v-btn>
            </div>

            <div class="or-saparator">
              <span>{{$lang.login.or}}</span>
            </div>

              <div class="field">
                <v-text-field
                  required
                  :rules="nameRules"
                  class="inputs"
                  v-model="firstName"
                  :placeholder="$lang.login.name"
                  :disabled="isLoginLoading"
                  autocomplete="name"
                  solo
                  flat
                  dense
                ></v-text-field>
              </div>

              <div class="field">
                <v-text-field
                  required
                  :rules="emailRules"
                  v-model="email"
                  :placeholder="$lang.login.email_address"
                  :disabled="isLoginLoading"
                  autocomplete="email"
                  solo
                  flat
                  dense
                ></v-text-field>
              </div>

              <div class="field">
                <v-text-field
                  type="password"
                  v-model="password"
                  :placeholder="$lang.login.password"
                  required
                  :rules="passwordRules"
                  :disabled="isLoginLoading"
                  password-reveal
                  solo
                  flat
                  dense
                ></v-text-field>
              </div>

              <div class="field">
                <v-text-field
                  type="password"
                  v-model="confirmPassword"
                  :placeholder="$lang.login.confirm_password"
                  required
                  :rules="confirmPasswordRules"
                  :disabled="isLoginLoading"
                  password-reveal
                  solo
                  flat
                  dense
                ></v-text-field>
              </div>

              <v-card class="none" v-show="!!loginError" height="10px" width="100%">
                <span class="error-message">{{ loginError }}</span>
              </v-card>

              <v-btn
                class="button round signup"
                color="success"
                :loading="isLoginLoading"
                :disabled="isLoginLoading"
                type="button"
                @click="signUp"
              >{{$lang.login.create_account}}</v-btn>

              <p>
                {{$lang.login.or_go_back_to}}
                <a @click="onLogin">{{$lang.login.login.toLowerCase()}}</a>
              </p>
            </v-form>
          </div>
        </div>
      </v-fade-transition>
    </section>
  </div>
</template>

<script>
import LoaderIcon from "../components/icons/LoaderIcon";
import textHelper from "@/utils/textManager";
import UserService from '../connections/user.service';

export default {
  components: {
    LoaderIcon
  },
  name: "InvitePage",
  data() {
    return {
      userExist: false,
      isLoginLoading: false,
      isPageLoading: true,
      inviteDesc:'',
      email: "",
      emailRules: [],
      password: "",
      confirmPassword:"",
      passwordRules:[],
      confirmPasswordRules:[],
      firstName: "",
      lastName: "",
      loginError: "",
      nameRules:[],
      referralUser:''
    };
  },
  methods: {
    onLogin: function(){
      const me = this;
      
          me.$router.push({ name: 'login' })
    },
    signUp: function() {
      const me = this;
      if (me.isFormValid) {
        me.isLoginLoading = true;
        UserService.getUserSignupPromise(me.email, me.password)
          .then(
            function() {
              UserService.sendEmailVerification();
              return UserService.createIdToken(true)
            },
            function(err) {
              me.loginError = me.$lang.error[err.code];
            }
          ).then(idToken => {
              return new Promise(resolve => setTimeout(() => resolve(idToken), 6000));
          }).then(function(){
              return UserService.updateUser({displayName: me.firstName, referredBy: me.referralUser});
          }).then(function(){
              return UserService.getSignOutPromise();
          }).then(
          function () {
            const message = {
              title:me.$lang.login.check_to_verify_header,
              body: me.$lang.login.check_to_verify + '<div class="fading-line"></div>'
            }
            me.$dialog.alert(message,{
              customClass: 'taption-dialog alert',
              okText: me.$lang.common.ok,
              html:true
            });
              me.$router.push({ name: "login" });
          })
          .finally(function() {
            me.isLoginLoading = false;
          });
      }
    },
    
    googleLogin: function() {
        const me = this;
        const provider = UserService.getGoogleAuthProvider();
        let referred = null;
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        me.isLoginLoading = true;
        
        UserService.getSignInWithPopupPromise(provider).then(
          function(result) {
              if(result.user && result.user.metadata && result.user.metadata.creationTime === result.user.metadata.lastSignInTime && me.referralUser){
                referred = {displayName: result.user.displayName || 'Taption User', referredBy: me.referralUser };
              }

              return result.user.getIdToken();
          },
          function(err) {
            me.loginError = me.$lang.error[err.code];
            me.errorCode = err.code;
            me.isLoginLoading = false;
            return Promise.resolve(false);
          }
        ).then(function(idtoken){
          if(idtoken){
            return UserService.appSignIn('login',idtoken);
          }
          
          return Promise.resolve(false);
        })
        .then(function(navigate){
          if(navigate && referred){
            setTimeout(async function(){
              await UserService.updateUser(referred);
              UserService.navigateToAppLoginPage();
            }, 5000);
          }
          else if(navigate){
            UserService.navigateToAppLoginPage();
          }
          else{
            me.isLoginLoading = false;
          }
        });
      },
  },
  computed: {
    isFormValid() {
      const me = this;
      return me.$refs.form.validate();
    },
    getLogoUrl() {
      const language =  textHelper.getDisplayLanguage();
      if(language === 'zh'){
        return { name: "taptiontw" };
      }
      else if(language === 'zh-CN'){
        return { name: "taptioncn" };
      }
      else if(language === 'en-US' || language === 'en'){
        return { name: "taption" };
      }
      else{
        return { name: `taption${language}` };
      }
    }
  },
  async created(){
    const me = this;
    const displayLanguage = textHelper.getDisplayLanguage(me.$route.params.language);

    window.localStorage.setItem('PrefferedLanguage', displayLanguage);
    me.$lang.setLang(displayLanguage);

    if(me.$route.params.id.indexOf('+') > -1){
      const chunks = me.$route.params.id.split('+');
      me.referralUser = chunks[0];
      try{
        const decodedString = textHelper.fromBase64(chunks[1].replace(/@/g, '/'));
        me.userExist = decodedString || 'Taption user';
      }
      catch{
        me.userExist = 'Taption user';
      }
    }
    else{
      me.referralUser = me.$route.params.id;
      me.userExist = await UserService.hasUserExistPromise(me.$route.params.id).then(function(result){
          return result && result.data;
      });
    }

    if(!me.userExist){
         me.$router.push({ name: "login" });
    }
    else{
        me.isPageLoading = false;
        me.inviteDesc = me.$lang.login.invite_desc;
        me.inviteDesc = me.inviteDesc.format(`<span class="referral">${me.userExist} </span>`);
    }
  },
  mounted() {
    const me = this;

    me.$refs.signupform.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) { 
        me.signUp();
      }
    });

    me.emailRules = [
      v =>
        !!v ||
        me.$lang.payment.required_field.format(me.$lang.login.email_address),
      v => /.+@.+\..+/.test(v) || me.$lang.error.email_must_be_valid
    ];

    me.passwordRules = [
      v => !!v || me.$lang.payment.required_field.format(me.$lang.login.password),
      v => (v && v.length >= 8) || me.$lang.error.must_be_more_than.format(8)
    ];


    me.confirmPasswordRules = [
        (value) => !!value || me.$lang.error.confirm_password_desc,
        (value) =>
          value === this.password || me.$lang.error.confirm_password_not_match,
    ];
    

    me.nameRules = [
      v => !!v || me.$lang.payment.required_field.format(me.$lang.login.name),
      v => (v && v.length <= 20) || me.$lang.error.must_be_less_than.format(20)
    ];

    setTimeout(function() {
      me.$refs.signupcontainer.classList.add("show");
    }, 100);
  }
};
</script>


<style scope>
h2 {
  font-weight: 400;
}
.invite-page{
  height: 100%;
    background: rgb(216 240 236 / 20%);
}
.invite-page .logo{
  position: absolute;
    top: 42px;
    left: 75px;
}
.signup-container {
  -webkit-transition: all 200ms ease-in;
  -moz-transition: all 200ms ease-in;
  -o-transition: all 200ms ease-in;
  transition: all 200ms ease-in;
  height:inherit;
  opacity: 0;
}
.signup-container.show {
  opacity: 1;
}
.signup-card a{
  color: #2fc59f !important;
  text-decoration: underline !important;
}

.authentication-form {
  height:inherit;
}

.authentication-form a:hover{
  color: #007bff!important;
}

.authentication-form .signup-card {
  box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
  cursor: default !important;

  border-radius: 0px 0px 10px 10px;
  height: 470px;
  z-index: 2;
  background:white;
}
.authentication-form p {
  text-align: left;
  font-size: 14px;
  margin-top:10px;
}

.authentication-form{
    justify-content: center;
    display: flex;
    align-items: center;
    margin-top: 0px !important;
    padding-top:0px!important;
    
  }

  .authentication-form .card {
    border: 0;
    padding: 25px 50px 50px;
    width: 500px;
    margin: 0 auto;
    box-shadow: 0 1px 10px rgba(1, 1, 1, 0.25);
    background: white;
  }

.invite-card.card{
    height:100px!important;
    text-align: center;
    border-radius: 10px 10px 0px 0px; 
    position:relative;
    border-bottom: 3px solid #1ad7dd !important;
    background:white;
}
.signup-header {
  margin-top: 50px;
  border-radius: 0px 0px 10px 10px; 
}

.signup-form {
  margin: 0 auto;
  width: 400px;
  height: auto;
  padding: 30px;
  background: whitesmoke;
  border: 0px solid #6eb7e7;
  box-shadow: 0 5px 12px rgba(1, 1, 1, 0.15);
  -webkit-box-shadow: 0 5px 12px rgba(1, 1, 1, 0.15);
}

.v-btn.round.signup {
  width: 400px ;
  height: 45px !important;
  border-radius: 20px;
  /* margin: 50px 0px !important; */
}

.v-card.none {
  border: 0 !important;
  box-shadow: none !important;
}

.social-btns .firebaseui-idp-icon {
  margin-right: 20px;
  margin-bottom: 5px;
}
.social-btns .ggl {
  width: 100%!important;
  background-image: none;
    color: gray!important;
  background-color: white!important;
  text-transform: none !important;
  font-family: Roboto, sans-serif;
      letter-spacing: 0.5px;
          height: 45px!important;

  border-radius: 20px;
}

.social-btns .ggl::before {
  transition: none;
  background-color: white!important;
  background-image: none;
  -webkit-box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)!important;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)!important;
}

.google-button__icon{
  padding: 8px;
}

.invite-loader-icon{
    position:absolute;
  top: 50% !important;
  left: 50% !important;
  z-index:0;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}

</style>


<style>

.referral{
    color:#1195f5;
    display: contents;
}

.referral-bonus{
    color:#00d1b2;
    display: contents;
}

.referral-note{
    position:absolute;
    color:gray;
    font-size: 12px;
    right:50px;
    bottom:10px;
}

.taption section {
    margin-top: 0px !important;
}

.signup-container section{
  margin-top: 0px !important;
}

.signup-card .v-input__slot{
  padding:0px!important;
}

.signup-card input{
  margin-bottom:0px;
}

.invite-page::before{
    content:"";
    background-image: url('../assets/images/login-background.webp')!important;
    background-repeat: repeat;
    opacity: 0.1;
    z-index: 0;
  background-size:contain;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  }

</style>
